export const countryData = [
  {
    callingCode: '+93',
    code: 'AF',
    name: 'Afghanistan',
  },
  {
    callingCode: '+355',
    code: 'AL',
    name: 'Albania',
  },
  {
    callingCode: '+213',
    code: 'DZ',
    name: 'Algeria',
  },
  {
    callingCode: '+1',
    code: 'AS',
    name: 'American Samoa',
  },
  {
    callingCode: '+376',
    code: 'AD',
    name: 'Andorra',
  },
  {
    callingCode: '+244',
    code: 'AO',
    name: 'Angola',
  },
  {
    callingCode: '+1',
    code: 'AI',
    name: 'Anguilla',
  },
  {
    callingCode: '+1',
    code: 'AG',
    name: 'Antigua',
  },
  {
    callingCode: '+54',
    code: 'AR',
    name: 'Argentina',
  },
  {
    callingCode: '+374',
    code: 'AM',
    name: 'Armenia',
  },
  {
    callingCode: '+297',
    code: 'AW',
    name: 'Aruba',
  },
  {
    callingCode: '+61',
    code: 'AU',
    name: 'Australia',
  },
  {
    callingCode: '+43',
    code: 'AT',
    name: 'Austria',
  },
  {
    callingCode: '+994',
    code: 'AZ',
    name: 'Azerbaijan',
  },
  {
    callingCode: '+973',
    code: 'BH',
    name: 'Bahrain',
  },
  {
    callingCode: '+880',
    code: 'BD',
    name: 'Bangladesh',
  },
  {
    callingCode: '+1',
    code: 'BB',
    name: 'Barbados',
  },
  {
    callingCode: '+375',
    code: 'BY',
    name: 'Belarus',
  },
  {
    callingCode: '+32',
    code: 'BE',
    name: 'Belgium',
  },
  {
    callingCode: '+501',
    code: 'BZ',
    name: 'Belize',
  },
  {
    callingCode: '+229',
    code: 'BJ',
    name: 'Benin',
  },
  {
    callingCode: '+1',
    code: 'BM',
    name: 'Bermuda',
  },
  {
    callingCode: '+975',
    code: 'BT',
    name: 'Bhutan',
  },
  {
    callingCode: '+591',
    code: 'BO',
    name: 'Bolivia',
  },
  {
    callingCode: '+387',
    code: 'BA',
    name: 'Bosnia and Herzegovina',
  },
  {
    callingCode: '+267',
    code: 'BW',
    name: 'Botswana',
  },
  {
    callingCode: '+55',
    code: 'BR',
    name: 'Brazil',
  },
  {
    callingCode: '+246',
    code: 'IO',
    name: 'British Indian Ocean Territory',
  },
  {
    callingCode: '+1',
    code: 'VG',
    name: 'British Virgin Islands',
  },
  {
    callingCode: '+673',
    code: 'BN',
    name: 'Brunei',
  },
  {
    callingCode: '+359',
    code: 'BG',
    name: 'Bulgaria',
  },
  {
    callingCode: '+226',
    code: 'BF',
    name: 'Burkina Faso',
  },
  {
    callingCode: '+95',
    code: 'MM',
    name: 'Burma Myanmar',
  },
  {
    callingCode: '+257',
    code: 'BI',
    name: 'Burundi',
  },
  {
    callingCode: '+855',
    code: 'KH',
    name: 'Cambodia',
  },
  {
    callingCode: '+237',
    code: 'CM',
    name: 'Cameroon',
  },
  {
    callingCode: '+1',
    code: 'CA',
    name: 'Canada',
  },
  {
    callingCode: '+238',
    code: 'CV',
    name: 'Cape Verde',
  },
  {
    callingCode: '+1',
    code: 'KY',
    name: 'Cayman Islands',
  },
  {
    callingCode: '+236',
    code: 'CF',
    name: 'Central African Republic',
  },
  {
    callingCode: '+235',
    code: 'ID',
    name: 'Chad',
  },
  {
    callingCode: '+56',
    code: 'CL',
    name: 'Chile',
  },
  {
    callingCode: '+86',
    code: 'CN',
    name: 'China',
  },
  {
    callingCode: '+57',
    code: 'CO',
    name: 'Colombia',
  },
  {
    callingCode: '+269',
    code: 'KM',
    name: 'Comoros',
  },
  {
    callingCode: '+682',
    code: 'CK',
    name: 'Cook Islands',
  },
  {
    callingCode: '+506',
    code: 'CR',
    name: 'Costa Rica',
  },
  {
    callingCode: '+225',
    code: 'CI',
    name: "Côte d'Ivoire",
  },
  {
    callingCode: '+385',
    code: 'HR',
    name: 'Croatia',
  },
  {
    callingCode: '+53',
    code: 'CU',
    name: 'Cuba',
  },
  {
    callingCode: '+357',
    code: 'CY',
    name: 'Cyprus',
  },
  {
    callingCode: '+420',
    code: 'CZ',
    name: 'Czech Republic',
  },
  {
    callingCode: '+243',
    code: 'CD',
    name: 'Democratic Republic of Congo',
  },
  {
    callingCode: '+45',
    code: 'DK',
    name: 'Denmark',
  },
  {
    callingCode: '+253',
    code: 'DJ',
    name: 'Djibouti',
  },
  {
    callingCode: '+1',
    code: 'DM',
    name: 'Dominica',
  },
  {
    callingCode: '+1',
    code: 'DO',
    name: 'Dominican Republic',
  },
  {
    callingCode: '+593',
    code: 'EC',
    name: 'Ecuador',
  },
  {
    callingCode: '+20',
    code: 'EG',
    name: 'Egypt',
  },
  {
    callingCode: '+503',
    code: 'SV',
    name: 'El Salvador',
  },
  {
    callingCode: '+240',
    code: 'GQ',
    name: 'Equatorial Guinea',
  },
  {
    callingCode: '+291',
    code: 'ER',
    name: 'Eritrea',
  },
  {
    callingCode: '+372',
    code: 'EE',
    name: 'Estonia',
  },
  {
    callingCode: '+251',
    code: 'ET',
    name: 'Ethiopia',
  },
  {
    callingCode: '+500',
    code: 'FK',
    name: 'Falkland Islands',
  },
  {
    callingCode: '+298',
    code: 'FO',
    name: 'Faroe Islands',
  },
  {
    callingCode: '+691',
    code: 'FM',
    name: 'Federated States of Micronesia',
  },
  {
    callingCode: '+679',
    code: 'FJ',
    name: 'Fiji',
  },
  {
    callingCode: '+358',
    code: 'FI',
    name: 'Finland',
  },
  {
    callingCode: '+33',
    code: 'FR',
    name: 'France',
  },
  {
    callingCode: '+594',
    code: 'GF',
    name: 'French Guiana',
  },
  {
    callingCode: '+689',
    code: 'PF',
    name: 'French Polynesia',
  },
  {
    callingCode: '+241',
    code: 'GA',
    name: 'Gabon',
  },
  {
    callingCode: '+995',
    code: 'GE',
    name: 'Georgia',
  },
  {
    callingCode: '+49',
    code: 'DE',
    name: 'Germany',
  },
  {
    callingCode: '+233',
    code: 'GH',
    name: 'Ghana',
  },
  {
    callingCode: '+350',
    code: 'GI',
    name: 'Gibraltar',
  },
  {
    callingCode: '+30',
    code: 'GR',
    name: 'Greece',
  },
  {
    callingCode: '+299',
    code: 'GL',
    name: 'Greenland',
  },
  {
    callingCode: '+1',
    code: 'GD',
    name: 'Grenada',
  },
  {
    callingCode: '+590',
    code: 'GP',
    name: 'Guadeloupe',
  },
  {
    callingCode: '+1',
    code: 'GU',
    name: 'Guam',
  },
  {
    callingCode: '+502',
    code: 'GT',
    name: 'Guatemala',
  },
  {
    callingCode: '+224',
    code: 'GN',
    name: 'Guinea',
  },
  {
    callingCode: '+245',
    code: 'GW',
    name: 'Guinea-Bissau',
  },
  {
    callingCode: '+592',
    code: 'GY',
    name: 'Guyana',
  },
  {
    callingCode: '+509',
    code: 'HT',
    name: 'Haiti',
  },
  {
    callingCode: '+504',
    code: 'HN',
    name: 'Honduras',
  },
  {
    callingCode: '+852',
    code: 'HK',
    name: 'Hong Kong',
  },
  {
    callingCode: '+36',
    code: 'HU',
    name: 'Hungary',
  },
  {
    callingCode: '+354',
    code: 'IS',
    name: 'Iceland',
  },
  {
    callingCode: '+91',
    code: 'IN',
    name: 'India',
  },
  {
    callingCode: '+62',
    code: 'ID',
    name: 'Indonesia',
  },
  {
    callingCode: '+98',
    code: 'IR',
    name: 'Iran',
  },
  {
    callingCode: '+964',
    code: 'IQ',
    name: 'Iraq',
  },
  {
    callingCode: '+353',
    code: 'IE',
    name: 'Ireland',
  },
  {
    callingCode: '+972',
    code: 'IL',
    name: 'Israel',
  },
  {
    callingCode: '+39',
    code: 'IT',
    name: 'Italy',
  },
  {
    callingCode: '+1',
    code: 'JM',
    name: 'Jamaica',
  },
  {
    callingCode: '+81',
    code: 'JP',
    name: 'Japan',
  },
  {
    callingCode: '+962',
    code: 'JO',
    name: 'Jordan',
  },
  {
    callingCode: '+7',
    code: 'KZ',
    name: 'Kazakhstan',
  },
  {
    callingCode: '+254',
    code: 'KE',
    name: 'Kenya',
  },
  {
    callingCode: '+686',
    code: 'KI',
    name: 'Kiribati',
  },
  {
    callingCode: '+381',
    code: 'XK',
    name: 'Kosovo',
  },
  {
    callingCode: '+965',
    code: 'KW',
    name: 'Kuwait',
  },
  {
    callingCode: '+996',
    code: 'KG',
    name: 'Kyrgyzstan',
  },
  {
    callingCode: '+856',
    code: 'LA',
    name: 'Laos',
  },
  {
    callingCode: '+371',
    code: 'LV',
    name: 'Latvia',
  },
  {
    callingCode: '+961',
    code: 'LB',
    name: 'Lebanon',
  },
  {
    callingCode: '+266',
    code: 'LS',
    name: 'Lesotho',
  },
  {
    callingCode: '+231',
    code: 'LR',
    name: 'Liberia',
  },
  {
    callingCode: '+218',
    code: 'LY',
    name: 'Libya',
  },
  {
    callingCode: '+423',
    code: 'LI',
    name: 'Liechtenstein',
  },
  {
    callingCode: '+370',
    code: 'LT',
    name: 'Lithuania',
  },
  {
    callingCode: '+352',
    code: 'LU',
    name: 'Luxembourg',
  },
  {
    callingCode: '+853',
    code: 'MO',
    name: 'Macau',
  },
  {
    callingCode: '+389',
    code: 'MK',
    name: 'Macedonia',
  },
  {
    callingCode: '+261',
    code: 'MG',
    name: 'Madagascar',
  },
  {
    callingCode: '+265',
    code: 'MW',
    name: 'Malawi',
  },
  {
    callingCode: '+60',
    code: 'MY',
    name: 'Malaysia',
  },
  {
    callingCode: '+960',
    code: 'MV',
    name: 'Maldives',
  },
  {
    callingCode: '+223',
    code: 'ML',
    name: 'Mali',
  },
  {
    callingCode: '+356',
    code: 'MT',
    name: 'Malta',
  },
  {
    callingCode: '+692',
    code: 'MH',
    name: 'Marshall Islands',
  },
  {
    callingCode: '+596',
    code: 'MQ',
    name: 'Martinique',
  },
  {
    callingCode: '+222',
    code: 'MR',
    name: 'Mauritania',
  },
  {
    callingCode: '+230',
    code: 'MU',
    name: 'Mauritius',
  },
  {
    callingCode: '+262',
    code: 'YT',
    name: 'Mayotte',
  },
  {
    callingCode: '+52',
    code: 'MX',
    name: 'Mexico',
  },
  {
    callingCode: '+373',
    code: 'MD',
    name: 'Moldova',
  },
  {
    callingCode: '+377',
    code: 'MC',
    name: 'Monaco',
  },
  {
    callingCode: '+976',
    code: 'MN',
    name: 'Mongolia',
  },
  {
    callingCode: '+382',
    code: 'ME',
    name: 'Montenegro',
  },
  {
    callingCode: '+1',
    code: 'MS',
    name: 'Montserrat',
  },
  {
    callingCode: '+212',
    code: 'MA',
    name: 'Morocco',
  },
  {
    callingCode: '+258',
    code: 'MZ',
    name: 'Mozambique',
  },
  {
    callingCode: '+264',
    code: 'NA',
    name: 'Namibia',
  },
  {
    callingCode: '+674',
    code: 'NR',
    name: 'Nauru',
  },
  {
    callingCode: '+977',
    code: 'NP',
    name: 'Nepal',
  },
  {
    callingCode: '+31',
    code: 'NL',
    name: 'Netherlands',
  },
  {
    callingCode: '+599',
    code: 'AN',
    name: 'Netherlands Antilles',
  },
  {
    callingCode: '+687',
    code: 'NC',
    name: 'New Caledonia',
  },
  {
    callingCode: '+64',
    code: 'NZ',
    name: 'New Zealand',
  },
  {
    callingCode: '+505',
    code: 'NI',
    name: 'Nicaragua',
  },
  {
    callingCode: '+227',
    code: 'NE',
    name: 'Niger',
  },
  {
    callingCode: '+234',
    code: 'NG',
    name: 'Nigeria',
  },
  {
    callingCode: '+683',
    code: 'NU',
    name: 'Niue',
  },
  {
    callingCode: '+672',
    code: 'NF',
    name: 'Norfolk Island',
  },
  {
    callingCode: '+850',
    code: 'KP',
    name: 'North Korea',
  },
  {
    callingCode: '+1',
    code: 'MP',
    name: 'Northern Mariana Islands',
  },
  {
    callingCode: '+47',
    code: 'NO',
    name: 'Norway',
  },
  {
    callingCode: '+968',
    code: 'OM',
    name: 'Oman',
  },
  {
    callingCode: '+92',
    code: 'PK',
    name: 'Pakistan',
  },
  {
    callingCode: '+680',
    code: 'PW',
    name: 'Palau',
  },
  {
    callingCode: '+970',
    code: 'PS',
    name: 'Palestine',
  },
  {
    callingCode: '+507',
    code: 'PA',
    name: 'Panama',
  },
  {
    callingCode: '+675',
    code: 'PG',
    name: 'Papua New Guinea',
  },
  {
    callingCode: '+595',
    code: 'PY',
    name: 'Paraguay',
  },
  {
    callingCode: '+51',
    code: 'PE',
    name: 'Peru',
  },
  {
    callingCode: '+63',
    code: 'PH',
    name: 'Philippines',
  },
  {
    callingCode: '+48',
    code: 'PL',
    name: 'Poland',
  },
  {
    callingCode: '+351',
    code: 'PT',
    name: 'Portugal',
  },
  {
    callingCode: '+1',
    code: 'PR',
    name: 'Puerto Rico',
  },
  {
    callingCode: '+974',
    code: 'QA',
    name: 'Qatar',
  },
  {
    callingCode: '+242',
    code: 'CG',
    name: 'Republic of the Congo',
  },
  {
    callingCode: '+262',
    code: 'RE',
    name: 'Réunion',
  },
  {
    callingCode: '+40',
    code: 'RO',
    name: 'Romania',
  },
  {
    callingCode: '+7',
    code: 'RU',
    name: 'Russia',
  },
  {
    callingCode: '+250',
    code: 'RW',
    name: 'Rwanda',
  },
  {
    callingCode: '+590',
    code: 'BL',
    name: 'Saint Barthélemy',
  },
  {
    callingCode: '+290',
    code: 'SH',
    name: 'Saint Helena',
  },
  {
    callingCode: '+1',
    code: 'KN',
    name: 'Saint Kitts and Nevis',
  },
  {
    callingCode: '+590',
    code: 'MF',
    name: 'Saint Martin',
  },
  {
    callingCode: '+508',
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
  },
  {
    callingCode: '+1',
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
  },
  {
    callingCode: '+685',
    code: 'WS',
    name: 'Samoa',
  },
  {
    callingCode: '+378',
    code: 'SM',
    name: 'San Marino',
  },
  {
    callingCode: '+239',
    code: 'ST',
    name: 'São Tomé and Príncipe',
  },
  {
    callingCode: '+966',
    code: 'SA',
    name: 'Saudi Arabia',
  },
  {
    callingCode: '+221',
    code: 'SN',
    name: 'Senegal',
  },
  {
    callingCode: '+381',
    code: 'RS',
    name: 'Serbia',
  },
  {
    callingCode: '+248',
    code: 'SC',
    name: 'Seychelles',
  },
  {
    callingCode: '+232',
    code: 'SL',
    name: 'Sierra Leone',
  },
  {
    callingCode: '+65',
    code: 'SG',
    name: 'Singapore',
  },
  {
    callingCode: '+421',
    code: 'SK',
    name: 'Slovakia',
  },
  {
    callingCode: '+386',
    code: 'SI',
    name: 'Slovenia',
  },
  {
    callingCode: '+677',
    code: 'SB',
    name: 'Solomon Islands',
  },
  {
    callingCode: '+252',
    code: 'SO',
    name: 'Somalia',
  },
  {
    callingCode: '+27',
    code: 'ZA',
    name: 'South Africa',
  },
  {
    callingCode: '+82',
    code: 'KR',
    name: 'South Korea',
  },
  {
    callingCode: '+34',
    code: 'ES',
    name: 'Spain',
  },
  {
    callingCode: '+94',
    code: 'LK',
    name: 'Sri Lanka',
  },
  {
    callingCode: '+1',
    code: 'LC',
    name: 'St. Lucia',
  },
  {
    callingCode: '+249',
    code: 'SD',
    name: 'Sudan',
  },
  {
    callingCode: '+597',
    code: 'SR',
    name: 'Suriname',
  },
  {
    callingCode: '+268',
    code: 'SZ',
    name: 'Swaziland',
  },
  {
    callingCode: '+46',
    code: 'SE',
    name: 'Sweden',
  },
  {
    callingCode: '+41',
    code: 'CH',
    name: 'Switzerland',
  },
  {
    callingCode: '+963',
    code: 'SY',
    name: 'Syria',
  },
  {
    callingCode: '+886',
    code: 'TW',
    name: 'Taiwan',
  },
  {
    callingCode: '+992',
    code: 'TJ',
    name: 'Tajikistan',
  },
  {
    callingCode: '+255',
    code: 'TZ',
    name: 'Tanzania',
  },
  {
    callingCode: '+66',
    code: 'TH',
    name: 'Thailand',
  },
  {
    callingCode: '+1',
    code: 'BS',
    name: 'The Bahamas',
  },
  {
    callingCode: '+220',
    code: 'GM',
    name: 'The Gambia',
  },
  {
    callingCode: '+670',
    code: 'TL',
    name: 'Timor-Leste',
  },
  {
    callingCode: '+228',
    code: 'TG',
    name: 'Togo',
  },
  {
    callingCode: '+690',
    code: 'TK',
    name: 'Tokelau',
  },
  {
    callingCode: '+676',
    code: 'TO',
    name: 'Tonga',
  },
  {
    callingCode: '+1',
    code: 'TT',
    name: 'Trinidad and Tobago',
  },
  {
    callingCode: '+216',
    code: 'TN',
    name: 'Tunisia',
  },
  {
    callingCode: '+90',
    code: 'TR',
    name: 'Turkey',
  },
  {
    callingCode: '+993',
    code: 'TM',
    name: 'Turkmenistan',
  },
  {
    callingCode: '+1',
    code: 'TC',
    name: 'Turks and Caicos Islands',
  },
  {
    callingCode: '+688',
    code: 'TV',
    name: 'Tuvalu',
  },
  {
    callingCode: '+256',
    code: 'UG',
    name: 'Uganda',
  },
  {
    callingCode: '+380',
    code: 'UA',
    name: 'Ukraine',
  },
  {
    callingCode: '+971',
    code: 'AE',
    name: 'United Arab Emirates',
  },
  {
    callingCode: '+44',
    code: 'GB',
    name: 'United Kingdom',
  },
  {
    callingCode: '+1',
    code: 'US',
    name: 'United States',
  },
  {
    callingCode: '+598',
    code: 'UY',
    name: 'Uruguay',
  },
  {
    callingCode: '+1',
    code: 'VI',
    name: 'US Virgin Islands',
  },
  {
    callingCode: '+998',
    code: 'UZ',
    name: 'Uzbekistan',
  },
  {
    callingCode: '+678',
    code: 'VU',
    name: 'Vanuatu',
  },
  {
    callingCode: '+39',
    code: 'VA',
    name: 'Vatican City',
  },
  {
    callingCode: '+58',
    code: 'VE',
    name: 'Venezuela',
  },
  {
    callingCode: '+84',
    code: 'VN',
    name: 'Vietnam',
  },
  {
    callingCode: '+681',
    code: 'WF',
    name: 'Wallis and Futuna',
  },
  {
    callingCode: '+967',
    code: 'YE',
    name: 'Yemen',
  },
  {
    callingCode: '+260',
    code: 'ZM',
    name: 'Zambia',
  },
  {
    callingCode: '+263',
    code: 'ZW',
    name: 'Zimbabwe',
  },
]
